/* eslint-disable */
const terms = "He llegit i accepto els {{terms_and_conditions}} de Time Out"
export default {
  'ca-ES': {
    common: {
      NAME_HOLDER: "Nom *",
      LAST_NAME_HOLDER: "Cognom *",
      EMAIL_HOLDER: "Correu electrònic *",
      PASS_HOLDER: "Crear contrasenya *",
      REPEAT_PASS_HOLDER: "Repetir contrasenya *",
      BUTTON_EMAIL_SIGN_UP: "Inicia la sessió amb el teu correu electrònic",

      TERMS_AND_CONDITIONS: "termes i condicions",
      PRIVACY_POLICY: "política de privacitat",

      NEWSLETTER_CONSENT: "Accepto rebre comunicacions rellevants de Time Out, incloses notícies, esdeveniments, ofertes i promocions de clients.",
      TERM_OF_USE: terms,
      TERM_OF_USE_WITH_NEWSLETTERS: "He llegit i accepto els {{terms_and_conditions}} de Time Out, incloent-hi el registre a la newsletter",

      HEADER_TITLE: "Crear un compte de Time Out",
      JOIN_FB: "Uneix-te amb Facebook",
      JOIN_TW: "Uneix-te amb Twitter",
      JOIN_GG: "Uneix-te amb Google",
      JOIN_EM: "Uneix-te amb el teu correu electrònic",
      ALREADY_HAVE: "Ja tens un compte a Time Out?",
      CREATE_ACCOUNT_LOG_IN: "Connecta-t'hi",

      SIGN_IN_TITLE: "Inicia sessió",
      SIGN_IN_FB: "Inicia sessió amb Facebook",
      SIGN_IN_TW: "Inicia sessió amb Twitter",
      SIGN_IN_GG: "Inicia sessió amb Google",
      SIGN_IN_EM: "Inicia sessió amb el teu correu electrònic",
      YOUR_EMAIL: "El teu correu electrònic",
      YOUR_PASSWORD: "La teva contrasenya",
      REMEMBER: "Recorda'm",
      FORGOT: "Oblidar?",
      HAVE_ACCOUNT_YET: "Encara no tens compte de Time Out?",
      JOIN_HERE: "Uneix-te aquí",
      ALMOST_THERE: "Gairebé hi ets",

      FORGOT_HEADER: "Has oblidat la contrasenya?",
      FORGOT_SUBTITLE: "Cap problema. Posa el teu correu electrònic aquí a sota i t'enviarem un enllaç per a restaurar la contrasenya.",
      SEND_LINK: "Envia l'enllaç",

      RECEIVE_EMAIL: "Gràcies, aviat rebràs un correu electrònic",
      MANAGE_ACCOUNT: "Administra el teu compte",
      EDIT_DETAILS_HERE: "Pots editar els detalls del teu compte aquí",
      FIRST_NAME: "Nom",
      LAST_NAME: "Cognom",
      SCREEN_NAME: "Nom del perfil",
      EMAIL: "Correu electrònica",
      ACCOUNT_DETAILS: "Nom del compte",
      PASSWORD: "Contrasenya",
      SAVE_CHANGES: "Desa els canvis",
      UPLOAD_PIC: "Puja una nova foto de perfil",
      CHOOSE_PHOTO: "Escull una foto del teu dispositiu. El pes màxim és de 2 MB.",
      CLOSE_ACCOUNT: "Tanca el compte",
      PASSWORD_BELOW: "Pots canviar la teva contrasenya aquí a sota.",
      CURRENT_PASSWORD: "Contrasenya actual",
      NEW_PASSWORD: "Nova contrasenya",
      REPEAT_PASSWORD: "Repeteix la nova contrasenya",
      CONFIRM_PASSWORD: "Confirmar contraseña",

      OOPS: "Vaja,",
      ERROR_404_OCCURED: "S'ha produït un error…",
      ERROR_404_INFO: "Hem mogut la pàgina o bé ja no existeix.",
      ERROR_500_TITLE: "El servidor ha tornat a ",
      SMTH_BROKEN: "Alguna cosa no funciona.",
      INTERNAL_RED: "500 Internal Server Error",
      LET_KNOW_RED: "Sisplau, explica'ns què estaves fent quan ha succeït l'error. Ho arreglarem tan ràpid com sigui possible. Disculpa pels inconvenients que t'hem pogut causar.",
      ERROR_500_INFO: "what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.",

      EMAIL_ERROR: "Si us plau, introdueix una contrasenya",
      FIRST_NAME_ERROR: "Si us plau, introdueix el seu nom",
      LAST_NAME_ERROR: "Si us plau, introdueix el seu cognom",
      TERM_OF_USE_ERROR: "Heu d'acceptar els nostres termes d'ús",
      SIGN_IN_VALIDATION_ERROR: "Correu electrònic o contrasenya incorrectes. Sisplau, torna-ho a provar",
      ACCOUNT_PASSWORDS_VALIDATION: "La contrasenya no coincideix",
      WAS_IT: "Ha sigut alguna cosa que hem fet?",
      DELETE_ACCOUNT_TEXT: "Ens sap greu que vulguis esborrar el teu compte. Si hi ha alguna cosa que t'hagi fet marxar",
      DELETE_ACCOUNT: "Esborrar compte",
      CANCEL: "Cancel·la",

      UPDATE_PASSWORD: "Actualitzi la contrasenya",
      PASSWORD_UPDATE_SUCCESS: "La teva contrasenya ha estat actualitzada",
      ERROR_PASSWORD_LENGTH: "La contrasenya ha de contenir com a mínim 6 caràcters",

      ERROR_MISSING_SITE_PARAMETER: "Falta el paràmetre d'aplicació requerit: site",
      ERROR_ALREADY_REGISTERED: "Ja esteu registrat mitjançant el registre d'email. Inicieu la sessió mitjançant {{email}}",

      BACK: 'Enrere',
      HERE: 'aquí',
      GP_FORGOT_HEADER: 'He oblidat la teva contrasenya?',
      GP_PLANS_THANK_YOU_HEADER: 'Gràcies per la teva comanda!',
      GP_PLANS_THANK_YOU_DESCRIPTION: 'Un correu electrònic de confirmació està en camí cap a {{email}}',
      GP_PLANS_THANK_YOU_CONTINUE: 'Continueu al lloc',
      GP_FORGOT_SUBTITLE: `Cap problema. Només cal que introdueixis la teva adreça electrònica a continuació; t'enviarem un enllaç per restablir-la.`,
      GP_SEND_LINK: 'Restableix la meva contrasenya',
      GP_YOUR_EMAIL: 'La teva adreça de correu electrònic',
      GP_RECEIVE_EMAIL: `Gràcies, si ja us heu registrat prèviament amb nosaltres utilitzant aquesta adreça de correu electrònic, rebreu un correu electrònic en breu.`,
      GP_LOGIN_TITLE: 'Inicieu la sessió',
      GP_EXP_TITLE: "Escull una opció",
      GP_PLAN_1_TITLE: "Comprar i navegar sense anuncis",
      GP_PLAN_1_BULLET_1: "Una subscripció sense anuncis de Time Out permet llegir el lloc web de Time Out sense publicitat.",
      GP_PLAN_1_BULLET_2: "No compartirem cap de les teves dades amb els anunciants.",
      GP_PLAN_1_CTA: "Paga per rebutjar anuncis per 2€",
      GP_PLAN_2_TITLE: "Visitar Time Out con anuncios personalizados",
      GP_PLAN_2_BULLET_1: `Fes clic a "Torna a Acceptar-ho tot" si no vols subscriure't a Time Out Ad Free`,
      GP_PLAN_2_CTA: `Tornar a "Acceptar-ho tot"`,
      GP_HAVE_ACCOUNT_YET: "Ja tens un compte Time Out Ad Free?",
      GP_QA_TITLE: "Qualsevol pregunta?",
      GP_QA_QUESTION_1: "​​Què és Time Out sense anuncis?",
      GP_QA_ANSWER_1_PART1: "Per un pagament únic de 2 €, gaudiràs de Time Out completament lliure d'anuncis. Aquest és un pagament d'una sola vegada i limitat a 30 dies a partir de la data de compra<br /><br />No veuràs anuncis de display tradicionals, avantatges emergents ni anuncis de vídeo pre-roll que solen aparèixer en la nostra pàgina web. És el teu bitllet per a un viatge sense interrupcions mentre gaudeixes del millor de la ciutat. Quan diem \"sense seguiment\", volem dir que no utilitzarem cookies ni tecnologies similars per a seguir la teva activitat de navegació amb finalitats de publicitat personalitzada ni compartir dades amb tercers. No obstant això, sí que recopilem dades anònimes i agregats per a assegurar-nos que la nostra pàgina web funcioni correctament, per a entendre com està funcionant el nostre contingut i per a millorar contínuament la teva experiència, sempre d'acord amb la nostra ",
      GP_QA_ANSWER_1_PART2: ".<br/><br/><strong>Nota important:</strong> Tot i que eliminem els anuncis de display, això no afecta el contingut editorial propi de Time Out, que pot incloure reportatges patrocinats clarament indicats, articles natius o enllaços d'afiliats a esdeveniments i productes que recomanem de veritat. Aquests formen part de la nostra oferta editorial, no de publicitat de tercers.",
      GP_QA_QUESTION_2: "Time Out sense anuncis funcionarà en tots els meus dispositius?",
      GP_QA_ANSWER_2_PART1: "Absolutament! Time Out sense anuncis està intel·ligentment vinculat al teu compte de Time Out. Així, tant si estàs planificant la teva pròxima aventura des de l'ordinador, buscant inspiració a la teva tablet o consultant què passa al mòbil, només has d'iniciar sessió amb les teves credencials habituals de Time Out en qualsevol navegador web compatible, i l’experiència sense anuncis es reproduirà.<br/><br/>Ja tens un compte de Time Out Ad-Free? Inicia sessió ",
      GP_QA_ANSWER_2_PART2: ".",
      GP_QA_QUESTION_3: "Com accedeixo a Time Out sense anuncis si he iniciat sessió en un dispositiu però em moc a un altre?",
      GP_QA_ANSWER_3_PART1: "No hi ha problema! Assegura't d'haver iniciat sessió al teu compte de Time Out en el nou dispositiu. Si continues veient anuncis, refresca la pàgina o fes clic en l'enllaç de 'Gestionar cookies' al peu de pàgina de la nostra web. Això confirmarà el teu estat d'inici de sessió i aplicarà automàticament els teus avantatges de 'sense anuncis' i 'sense seguiment'.\nJa tens un compte? Inicia sessió ",
      GP_QA_ANSWER_3_PART2: ".",
      GP_QA_QUESTION_4: "Com puc contactar amb el servei d'atenció al client?",
      GP_QA_ANSWER_4_PART1: "Si experimentes qualsevol problema, el nostre equip de suport és aquí per a ajudar-te. Envia'ns un correu electrònic a support@timeout.com. El nostre objectiu és respondre a totes les consultes ràpidament",
      GP_QA_ANSWER_4_PART2: ".",
      GP_QA_QUESTION_5: "Quina és la vostra política de reemborsament?",
      GP_QA_ANSWER_5_PART1: "La nostra política de reemborsament completa, incloent qualsevol reemborsament prorratejat per a certes circumstàncies (per exemple, si cancel·les dins d'un període de desistiment), es detalla en els nostres ",
      GP_QA_ANSWER_5_PART2: ".",
      GP_CONFIRM_PAY: "Confirmar i pagar",
      GP_EDIT: "Editar",
      GP_TOTAL: "Total",
      GP_ORDER_TOTAL: "Total de comanda",
      GP_MONTH: "Mes",
      GP_CHK_PLAN_1_TITLE: "Time Out Ad-Free",
      GP_YOUR_DETAILS: "Les teves dades",
      GP_PAYMENT_METHOD: "Mètode de pagament",
      GP_NAME_CARD: "Nom del titular de la targeta",
      GP_CARD_NUMBER: "Número de targeta",
      GP_EXPIRY_DATE: "Data de caducitat",
      GP_CVV: "CVV",
      GP_POST_CODE: "Codi postal",
      GP_AD_FREE_TERMS_AND_CONDITIONS: "Termes i condicions de Time Out sense anuncis",
      GP_TERMS_AND_CONDITIONS: "termes d'ús",
      GP_PRIVACY_POLICY: "l'avís de privadesa",
      GP_ORDER_TERMS: "En completar aquesta comanda, accepteu els {{terms_and_conditions}}, {{privacy_policy}} i els {{ad_free_terms_and_conditions}}.",
      GP_ORDER_DISCLAIMER: "<strong>\"Sense anuncis\"</strong>: el servei sense anuncis està dissenyat per eliminar els anuncis gràfics, els anuncis emergents i els anuncis de vídeo previs als vídeos que solen aparèixer a les àrees de contingut editorial del nostre lloc web durant el període d'accés.",
      GP_PAY_VALUE: "Pagar {{value}}",
      BRAINTREE_cardholderName_ERROR: "error en el nom del titular de la targeta",
      BRAINTREE_number_ERROR: "error en el número de targeta",
      BRAINTREE_expirationDate_ERROR: "error en la data de caducitat de la targeta",
      BRAINTREE_cvv_ERROR: "error en la data CVV de la targeta",
      BRAINTREE_postalCode_ERROR: "error en el codi postal de la targeta",
      BRAINTREE_generic_ERROR: "error genèric",
      PAYMENT_AUTHORIZATION_FAILED: "Oops! Pagament no realitzat. Si us plau, revisa les teves dades i torna-ho a intentar.",
      GP_THANK_YOU_LOGIN_FAIL_MESSAGE: "Les teves dades d'inici de sessió són correctes, però Time Out ja no ofereix una subscripció sense anuncis."
    },
    'es-barcelona': { TERM_OF_USE: terms, },
    'es-madrid': { TERM_OF_USE: terms, },
    'es-girona': { TERM_OF_USE: terms, },
  }
}



// WEBPACK FOOTER //
// ./translations/ca-ES.js